// Single source of truth for the redesign overlay stack. Every floating surface portals to <body>, so
// they all end up siblings in the same stacking context and a raw z-index written inside one component
// silently buries another. The whole ladder lives here:
//
// 1090  fixed navbar (RedesignNavbar)
// 1100  dialog backdrop          1101  dialog content
// 1200  nested dialog backdrop   1201  nested dialog content (a dialog opened from inside a dialog)
// 1300  floating layers: popover, select dropdown, tooltip
// 1500  Google Drive picker (`.picker-dialog` in app.css, raised there because Google owns that markup)
//
// Floating layers sit ABOVE every dialog on purpose. They are opened from inside dialogs, nested ones
// included, so anything lower is hidden behind the dialog that owns the trigger. They cannot obscure a
// dialog the user could otherwise reach, because a popover only exists while its trigger does.
//
// These are full class literals rather than numbers: Tailwind scans the source for complete class names,
// so an interpolated `z-[${value}]` would never generate a utility.
export const Z_DIALOG_BACKDROP = 'z-[1100]';
export const Z_DIALOG_CONTENT = 'z-[1101]';
export const Z_NESTED_DIALOG_BACKDROP = 'z-[1200]';
export const Z_NESTED_DIALOG_CONTENT = 'z-[1201]';
export const Z_FLOATING = 'z-[1300]';
